import { render, staticRenderFns } from "./OrdenApprove.vue?vue&type=template&id=d5afdf5c&scoped=true&"
import script from "./OrdenApprove.vue?vue&type=script&lang=js&"
export * from "./OrdenApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5afdf5c",
  null
  
)

export default component.exports